/**
 * Haptic feedback utility for touch interactions
 * Uses the Vibration API where available
 */

type HapticStyle = 'light' | 'medium' | 'heavy' | 'success' | 'error' | 'selection';

const hapticPatterns: Record<HapticStyle, number | number[]> = {
  light: 10,
  medium: 20,
  heavy: 30,
  success: [10, 50, 20],
  error: [30, 50, 30, 50, 30],
  selection: 5,
};

/**
 * Trigger haptic feedback
 * @param style - The style of haptic feedback
 */
export function haptic(style: HapticStyle = 'light'): void {
  if (typeof navigator !== 'undefined' && 'vibrate' in navigator) {
    try {
      navigator.vibrate(hapticPatterns[style]);
    } catch (e) {
      // Silently fail if vibration not supported
    }
  }
}

/**
 * Haptic feedback for button press
 */
export function hapticButton(): void {
  haptic('light');
}

/**
 * Haptic feedback for selection (cards, options)
 */
export function hapticSelect(): void {
  haptic('selection');
}

/**
 * Haptic feedback for successful action
 */
export function hapticSuccess(): void {
  haptic('success');
}

/**
 * Haptic feedback for scroll snap
 */
export function hapticTick(): void {
  haptic('selection');
}

export default haptic;
